import {Exchange} from '../../enums/exchange';
import {Security} from '../../models/security';
import {SecurityKey} from '../../models/security-key';

export interface SmartSecurityKey extends SecurityKey {
    securityExchange: Exchange.SMART;
}

export interface SmartSecurity extends Security {
    id: null;
    securityExchange: Exchange.SMART;
}

export const isSmartExchange = (exchange: Exchange): boolean => {
    return exchange === Exchange.SMART;
};

export const isSmartSecurityKey = (securityKey: SecurityKey): securityKey is SmartSecurityKey => {
    return isSmartExchange(securityKey.securityExchange);
};

export const isSmartSecurity = (security: Security): security is SmartSecurity => {
    return isSmartSecurityKey(security);
};
